import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import {
  CreateContainerRequest,
  DeleteContainerRequest,
  ModifyContainerRequest,
} from "interfaces/requests/Container";

const BASE_URL = "/containers";

export const fetchContainers = createAsyncThunk("containers/get", async () => {
  try {
    const response = await axios.get(`${BASE_URL}/`);
    return response.data.data;
  } catch (error: any) {
    console.log("Error - fetchContainers ->", error);
    throw new Error(error.message);
  }
});

export const addContainer = createAsyncThunk(
  "containers/add",
  async (request: CreateContainerRequest) => {
    try {
      const response = await axios.post(`${BASE_URL}/`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - addContainer ->", error);
      throw new Error(error.message);
    }
  },
);

export const updateContainer = createAsyncThunk(
  "containers/update",
  async (request: ModifyContainerRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/${request._id}`, request);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - updateContainer ->", error);
      throw new Error(error.message);
    }
  },
);

export const removeContainer = createAsyncThunk(
  "containers/remove",
  async (request: DeleteContainerRequest) => {
    try {
      const response = await axios.put(`${BASE_URL}/delete/${request._id}`);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - removeContainer ->", error);
      throw new Error(error.message);
    }
  },
);
